let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Z99Q")).then(() => parcelRequire('18l55'));